import { toast } from 'react-toastify';
import { PartCollect } from '../../../shared/types/partCollect.ts';
import { Batch } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    batch: Batch | null | undefined;
    canCollect: boolean;
}

export function CollectButton({
    batch,
    canCollect,
}: Props) {
    const trpcUtils = trpc.useUtils();
    const collect = trpc.partCollect.collect.useMutation({
        onSuccess: async (partCollect) => {
            await trpcUtils.partCollect.get.invalidate({ equipment: partCollect.equipment });
        },
    });


    async function handleCollect() {
        if (!canCollect || !batch || collect.isPending) return;

        const input: Pick<PartCollect, 'equipment' | 'product' | 'batchStart'> = {
            equipment: batch.equipment,
            product: batch.product,
            batchStart: batch.start,
        };
        try {
            await collect.mutateAsync(input);
            toast.success('Part collected.');
        } catch (error) {
            console.error('Failed to save part collect:', error);
            toast.error(error instanceof Error ? error.message : 'Failed to save part collect.');
        }
    }


    return (
        <button
            disabled={!canCollect || collect.isPending}
            onClick={handleCollect}
            children='Collect'
        />
    );
}
